import { render, staticRenderFns } from "./provider-button.vue?vue&type=template&id=76bd4305&"
import script from "./provider-button.vue?vue&type=script&lang=js&"
export * from "./provider-button.vue?vue&type=script&lang=js&"
import style0 from "./provider-button.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./provider-button.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports